module.exports = __webpack_public_path__ + "img/icon-96x96.e3902baf.png";